import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useGetEventQuery } from '@/graphql/queries/getEvent.generated';
import { Routes } from '@/utils/routes';
import { formatShortDate } from '@/utils/formatter';
import i18n from '@/utils/i18n';

import { OrderDetailPage } from './components/details/OrderDetailPage';
import { EventOrderDetailsForm } from './EventOrderDetailsForm';
import { EmptyPage } from '@/components/EmptyPage';
import { Button } from '@/components/ui/button';
import { ArrowLeftIcon } from 'lucide-react';

export const EventOrderDetails: React.FC = () => {
  const { eventId, orderId } = useParams<{
    eventId: string;
    orderId: string;
  }>();
  const history = useHistory();

  const { data: eventData, loading: eventLoading } = useGetEventQuery({
    variables: { id: eventId },
  });

  const event = eventData?.event;
  const backRoute = Routes.eventDetailOrders(eventId);
  const backLabel = i18n.t('Order:breadcrumbBackToEventOrders');

  return (
    <OrderDetailPage
      orderId={orderId}
      breadcrumbLabel={(order) => {
        return `${event?.main_contracting_event_account?.name ?? i18n.t('Order:breadcrumbOrder')} (${formatShortDate(order.created_at)})`;
      }}
      backRoute={backRoute}
      backLabel={backLabel}
      additionalLoading={eventLoading}
    >
      {({ order, refetch }) =>
        event ? (
          <EventOrderDetailsForm
            order={order}
            event={event}
            refetch={refetch}
          />
        ) : (
          <div className="tw:mx-auto tw:flex tw:max-w-[1340px] tw:flex-col tw:items-center tw:gap-4 tw:p-6 tw:pt-20">
            <EmptyPage
              title={i18n.t('Event:noEventFound')}
              iconName="person-walk-directions"
            >
              <Button variant="outline" onClick={() => history.push(backRoute)}>
                <ArrowLeftIcon className="tw:mr-2 tw:size-4" />
                {backLabel}
              </Button>
            </EmptyPage>
          </div>
        )
      }
    </OrderDetailPage>
  );
};
